import React, { useState, useEffect, useRef } from "react";
import "./Carousel.css";
import { getSlidesCarrusel, isApiConfigured } from "../services/api";

import img1 from "./Assets/img/Carousel1.2.jpeg";
import img2 from "./Assets/img/Carousel2.2.jpeg";
import img3 from "./Assets/img/Carousel3.2.jpeg";

const defaultSlides = [
  { imagen: img1, urlBoton: "/musica",    textoBoton: "Conoce más", colorBoton: "yellow" },
  { imagen: img2, urlBoton: "/eventos",   textoBoton: "Conoce más", colorBoton: "orange" },
  { imagen: img3, urlBoton: "/aventuras", textoBoton: "Conoce más", colorBoton: "blue" },
];

export default function Carousel() {
  const [current, setCurrent] = useState(0);
  const [slides, setSlides] = useState(defaultSlides);
  const fetched = useRef(false);

  useEffect(() => {
    if (!isApiConfigured() || fetched.current) return;
    fetched.current = true;

    getSlidesCarrusel()
      .then((data) => {
        if (data && data.length > 0) {
          setSlides(data.map((s) => ({
            imagen:    s.imagen,
            textoBoton:s.textoBoton || "Conoce más",
            urlBoton:  s.urlBoton || "#",
            colorBoton:s.colorBoton || "blue",
          })));
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (slides.length === 0) return;
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="carousel">
      <div className="carousel-container"
      style={{ transform: `translateX(-${current * 100}%)` }}>
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide-wrapper ${index === current ? "active" : ""}`}
          >
            <img src={slide.imagen} alt={`slide-${index}`} className="slide" />

            <button
              className={`slide-button ${slide.colorBoton || "blue"}`}
              onClick={() => (window.location.href = slide.urlBoton)}
            >
              {slide.textoBoton}
            </button>
          </div>
        ))}
      </div>

      <div className="indicators">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === current ? "active" : ""}`}
            onClick={() => setCurrent(index)}
          />
        ))}
      </div>
    </div>
  );
}
